import React, { useEffect, useState } from "react";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString } from "utils/Constant";
import { ApiGetEdcLocation, ApiGetResellerList, ApiUpdateEdcLocation } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import SaveButton from "components/Button/SaveButton";
import Dropdown from "components/Input/Dropdown";

export default function EdcLocation(){
    const { fetch: getResellerList } = useFetch(ApiGetResellerList)
    const { fetch: getEdcLocation } = useFetch(ApiGetEdcLocation)
    const { fetch: updateEdcLocation } = useFetch(ApiUpdateEdcLocation)

    const [edcLocationList, setEdcLocationList] = useState([])
    const [resellerOptions, setResellerOptions] = useState([])
    
    const resellerChange = (index, key, value) => {
        const newData = [...edcLocationList];
        newData[index][key] = value;
        setEdcLocationList(newData);
    };

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading({isOpen: true})

        fGetResellerList().then(() => {
            fGetEdcLocation().then((res) => {
                setLoading({isOpen: false})
            })
        })
    },[])

    // Function Api Call
    async function fGetEdcLocation(){
        await getEdcLocation({
            data: {
                
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setEdcLocationList(response.data.listData)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetResellerList(){
        await getResellerList({
            data: {
                resellerName: EmptyString,
                pageSize: 10000,
                pageIndex: parseInt(0)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data.listData
                    let tempArray = []

                    tempArray.push({ label: "Select Reseller", value: "0" })

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].resellerName.toUpperCase(), value: String(data[i].resellerId) })
                    }

                    setResellerOptions(tempArray)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateEdcLocation(edcId, resellerId){
        await updateEdcLocation({
            data: {
                edcId: edcId,
                customerId: resellerId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { 
                    setSuccessModal({isOpen: false})
                }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    const saveBtnClick = (edcId, resellerId) => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fUpdateEdcLocation(edcId, resellerId).then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">EDC Location</span>
            </div>
            <hr />

            <div className="bg-white p-4 hidden sm:block">
                <div className="mt-5">
                    <table className="w-full border bg-white">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2 hidden sm:table-cell">EDC</th>
                                <th className="font-semibold text-left px-2 hidden sm:table-cell">Reseller Name</th>
                                <th className="font-semibold sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            {edcLocationList?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2">
                                            <span>{ data.bankCode.toUpperCase() + " - " + data.edcName.toUpperCase() }</span>
                                        </td>
                                        <td className="px-2">
                                            <Dropdown options={resellerOptions} value={String(data.customerId)} onChange={(e) => {resellerChange(i, 'customerId', e.value)}} />
                                        </td>
                                        <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                            <SaveButton className="p-2" visible={true} onClick={() => {saveBtnClick(data.edcId, data.customerId)}} />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className=" sm:hidden">
                <div className="mt-5 flex flex-col gap-2">
                    {edcLocationList?.map((data, i) => {
                        return(
                            <div className="bg-white border rounded-md p-2 flex flex-col gap-2">
                                <label className="font-semibold">{ data.bankCode.toUpperCase() + " - " + data.edcName.toUpperCase() }</label>
                                <div>
                                    <Dropdown options={resellerOptions} value={String(data.customerId)} onChange={(e) => {resellerChange(i, 'customerId', e.value)}} />
                                </div>
                                <div className="flex justify-end">
                                    <SaveButton className=" w-full" visible={true} onClick={() => {saveBtnClick(data.edcId, data.customerId)}} />
                                </div>
                            </div>
                            // <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                            //     <td className="text-center">{ data.rowNumber }</td>
                            //     <td className="px-2">
                            //         <span>{ data.bankCode.toUpperCase() + " - " + data.edcName.toUpperCase() }</span>
                            //     </td>
                            //     <td className="px-2">
                            //         <Dropdown options={resellerOptions} value={String(data.customerId)} onChange={(e) => {resellerChange(i, 'customerId', e.value)}} />
                            //     </td>
                            //     <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                            //         <SaveButton className="p-2" visible={true} onClick={() => {saveBtnClick(data.edcId, data.customerId)}} />
                            //     </td>
                            // </tr>
                        )
                    })}
                </div>
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}